import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId, scrollToTop } from "../lib/scroll";
import {
    NAV_LEFT,
    NAV_RIGHT,
    WHATSAPP,
} from "../data/content";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const navLink =
        "eyebrow link-underline transition-opacity hover:opacity-100 cursor-pointer bg-transparent border-0 p-0";
    const linkStyle = {
        color: scrolled ? "var(--ink)" : "rgba(252,251,248,0.92)",
        opacity: scrolled ? 0.65 : 1,
    };

    return (
        <header
            data-testid="site-header"
            className="fixed top-0 left-0 right-0 z-50 transition-colors duration-700"
            style={{
                backgroundColor: scrolled
                    ? "rgba(252,251,248,0.82)"
                    : "rgba(252,251,248,0)",
                backdropFilter: scrolled ? "blur(14px)" : "none",
                borderBottom: scrolled
                    ? "1px solid var(--line)"
                    : "1px solid transparent",
            }}
        >
            <div className="mx-auto grid grid-cols-2 items-center px-6 py-5 md:grid-cols-3 md:px-12">
                {/* Left nav */}
                <nav className="hidden items-center gap-8 md:flex">
                    {NAV_LEFT.map((l) => (
                        <button
                            key={l.href}
                            type="button"
                            onClick={() => scrollToId(l.href)}
                            className={navLink}
                            style={linkStyle}
                            data-testid={`nav-${l.href.slice(1)}`}
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                {/* Center logo */}
                <button
                    type="button"
                    onClick={scrollToTop}
                    data-testid="logo-link"
                    className="cursor-pointer justify-self-start bg-transparent p-0 md:justify-self-center"
                >
                    <span className="logo-frame inline-block" style={{ borderColor: scrolled ? "var(--ink)" : "rgba(252,251,248,0.85)" }}>
                        <span
                            className="font-serif text-2xl tracking-wide md:text-[26px]"
                            style={{ letterSpacing: "0.02em", color: scrolled ? "var(--ink)" : "var(--bg)" }}
                        >
                            Lady<span style={{ color: scrolled ? "var(--accent)" : "var(--bg)" }}>Art</span>
                        </span>
                    </span>
                </button>

                {/* Right nav + CTA */}
                <div className="hidden items-center justify-end gap-8 md:flex">
                    {NAV_RIGHT.map((l) => (
                        <button
                            key={l.href}
                            type="button"
                            onClick={() => scrollToId(l.href)}
                            className={navLink}
                            style={linkStyle}
                            data-testid={`nav-${l.href.slice(1)}`}
                        >
                            {l.label}
                        </button>
                    ))}
                    <a
                        href={WHATSAPP}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="header-book-btn"
                        className="eyebrow pill border px-6 py-3"
                        style={{
                            borderColor: "var(--ink)",
                            color: "var(--bg)",
                            backgroundColor: "var(--ink)",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "var(--accent)";
                            e.currentTarget.style.borderColor = "var(--accent)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "var(--ink)";
                            e.currentTarget.style.borderColor = "var(--ink)";
                        }}
                    >
                        Programează-te
                    </a>
                </div>

                {/* Mobile toggle */}
                <button
                    aria-label="Meniu"
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="justify-self-end md:hidden"
                    style={{ color: scrolled ? "var(--ink)" : "var(--bg)" }}
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {/* Mobile sheet */}
            <div
                className="overflow-hidden transition-[max-height] duration-500 md:hidden"
                style={{
                    maxHeight: open ? "420px" : "0px",
                    backgroundColor: "rgba(252,251,248,0.98)",
                    backdropFilter: "blur(14px)",
                }}
            >
                <div className="flex flex-col gap-6 px-6 pb-10 pt-4">
                    {[...NAV_LEFT, ...NAV_RIGHT].map((l) => (
                        <button
                            key={l.href}
                            type="button"
                            onClick={() => {
                                setOpen(false);
                                setTimeout(() => scrollToId(l.href), 60);
                            }}
                            className="cursor-pointer border-0 bg-transparent p-0 text-left font-serif text-3xl"
                            data-testid={`mobile-nav-${l.href.slice(1)}`}
                        >
                            {l.label}
                        </button>
                    ))}
                    <a
                        href={WHATSAPP}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="mobile-book-btn"
                        className="eyebrow pill mt-2 px-6 py-4 text-center"
                        style={{
                            backgroundColor: "var(--ink)",
                            color: "var(--bg)",
                        }}
                    >
                        Programează-te
                    </a>
                </div>
            </div>
        </header>
    );
}
